const PAGE_SIZE = 100;

/** Every row of a list the API serves a page at a time, 100 being the smallest cap of those lists. */
export const allPages = async <T>(read: (skip: number, limit: number) => Promise<T[]>): Promise<T[]> => {
  const rows: T[] = [];
  for (let skip = 0; ; skip += PAGE_SIZE) {
    const page = await read(skip, PAGE_SIZE);
    rows.push(...page);
    if (page.length < PAGE_SIZE) return rows;
  }
};
